/**
 * Liste des statuts possibles d'un export.
 */
export const ExportStatusEnum = {
	Waiting: 'En attente',
	WorkInProgress: 'En cours',
	Finalizing: 'Finalisation',
	Archived: 'Généré',
	Error: 'En échec',
	Cancelled: 'Annulé',
	Cancelling: 'Annulation',
	Deleting: 'Suppression'
};

/**
 * Liste des statuts possibles d'annuler un export.
 */
export const ExportStatusCancellableEnum = {
	Waiting: 'En attente',
	WorkInProgress: 'En cours',
	Finalizing: 'Finalisation'
};

/**
 * Liste des statuts possibles de supprimer un export.
 */
export const ExportStatusDeletableEnum = {
	Archived: 'Généré',
	Error: 'En échec',
	Cancelled: 'Annulé'
};
